import { CheckCircle2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function StatusPill({ runId }: { runId?: string }) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-2 rounded-full border border-line bg-panel-2 px-3 py-1.5 text-xs text-ink-2">
      <CheckCircle2 size={14} className="text-positive" aria-hidden="true" />
      <span className="font-semibold text-ink">{t('shell.baseline')}</span>
      {runId && <span className="hidden font-mono text-[10px] lg:inline">{runId}</span>}
    </div>
  )
}
